/**
 * React Query: серверный прогресс онбординга (единственный SoT).
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  onboardingApi,
  type StepCompleteResponse,
  type TourStateResponse,
} from "@/services/onboarding-api.service";

export const onboardingStateQueryKey = ["onboarding", "state"] as const;

export function useOnboardingState(enabled: boolean) {
  return useQuery({
    queryKey: onboardingStateQueryKey,
    queryFn: () => onboardingApi.getState(),
    enabled,
    staleTime: 30_000,
    retry: 1,
  });
}

export function useCompleteOnboardingStep() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tourKey: string) => onboardingApi.completeStep(tourKey),
    onSuccess: (data: StepCompleteResponse) => {
      if (data.is_finished) {
        void qc.invalidateQueries({ queryKey: onboardingStateQueryKey });
        return;
      }
      // Промежуточный шаг: обновляем кэш без refetch (антимигание tooltip)
      qc.setQueryData<TourStateResponse>(onboardingStateQueryKey, (prev) => {
        if (!prev || !prev.enabled) return prev;
        const order = data.current_step_order;
        const steps = prev.steps || [];
        return {
          ...prev,
          current_step_order: order,
          current_step: steps[order] ?? data.next_step ?? null,
          is_completed: false,
        };
      });
    },
  });
}

export function useDismissOnboardingTour() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tourKey: string) => onboardingApi.dismissTour(tourKey),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: onboardingStateQueryKey });
    },
  });
}
